module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0fd9fd69a38ab79358df5a77b29702c8.svg";